import React, {useState} from "react";
import "./profileAboutMeStyle.sass"
import SocialNetworks from "./ProfileAboutMeSocNetwork/SocialNetworks";
import ProfileStatus from "./ProfileAboutMeStatus/ProfileStatus";
import EditModeProfileContacts from "./ProfileAboutMeEditProfile/EditModeProfileContacts";
import editProfile from "../../../img/profileImg/editProfile.png"
import EditModeProfileData from "./ProfileAboutMeEditProfile/EditModeProfileData";
import settings from "../../../img/profileImg/settings.png"
import {Link} from "react-router-dom";

const ProfileAboutMe = ({profile, status, putStatus, putProfile, setImageProfile, isOwner, follow, unFollow, activeUserFollowed, waitingSubscripe}) => {

    let [editMode, setEditMode] = useState(false);
    let [editModeContacts, setEditModeContacts] = useState(false);


    const onSubmit = (object) => {
        setEditMode(false);
        setEditModeContacts(false);
        putProfile(object);
    };
    const onUpdatePhoto = (file) => {
        if (file.target.files.length)
            setImageProfile(file.target.files[0])
    };
    let contacts = Object.keys(profile.contacts).map(network => <SocialNetworks key={network} network={network} adres={profile.contacts[network]}/>);
    return (
        <div className="profile__about-me">
            <div className='profile__header'>
                <div className="profile__header-bg"><img src={profile.photos.large ? profile.photos.large : "https://gvk78.ru/no-foto.jpg"} alt=""/></div>
                <div className='profile__user'>
                    <div className='profile__user-avatar'><img src={profile.photos.small ? profile.photos.large : "https://gvk78.ru/no-foto.jpg"} alt=""/></div>
                    {isOwner ?
                        <div className='profile__user-settings' onChange={onUpdatePhoto}>
                            <img src={settings} alt=""/>
                            <input type="file"/>
                        </div> :
                    null}

                </div>
            </div>
            <div className="profile__links-content profile__main-blocks">
                <ul>
                    <li><Link to={'/profile'} className='additional-text'>Видео</Link></li>
                    <li><Link to={'/profile'} className='additional-text'>Обо мне</Link></li>
                     <li><p className='profile__user-name'><Link to={'/profile'}>{profile.fullName}</Link></p></li>
                    <li><Link to={'/profile'} className='additional-text'>Фото</Link></li>
                    <li><Link to={'/profile'} className='additional-text'>Друзья</Link></li>
                </ul>
            </div>
            <div className="profile__main-information ">
                <div className='profile__information-left-side profile__main-blocks'>
                    <p className='title-information main-text profile__margin'>Главная информация</p>
                    {!editMode &&
                        <>
                            {isOwner ? <button className="profile__button-edit-profile" onClick={() => setEditMode(true)}><img src={editProfile} alt=""/></button>:null}
                            <div className="profile__lists-about-profile profile__margin">
                                <div className="profile__list-about-profile">
                                    <p className='main-text'>Имя: </p>
                                    <p className='additional-text'>{profile.fullName}</p>
                                </div>
                                <div className="profile__list-about-profile">
                                    <p className='main-text'>Обо мне: </p>
                                    <p className='additional-text'>{profile.aboutMe ? profile.aboutMe : 'Отсутствует'}</p>
                                </div>
                                <div className="profile__list-about-profile">
                                    <p className='main-text'>Работа: </p>
                                    <p className='additional-text'>{profile.lookingForAJobDescription ? profile.lookingForAJobDescription : "Отсутствует"}</p>
                                </div>
                                <div className="profile__list-about-profile">
                                    <p className='main-text'>Cтатус: </p>
                                    <div className="additional-text input-style1 profile__input-style1"><ProfileStatus status={status} putStatus={putStatus}/></div>
                                </div>
                            </div>
                        </>}
                    {editMode && <EditModeProfileData status={status} putStatus={putStatus} initialValues={profile} onSubmit={onSubmit}/>}
                </div>
                <div className='profile__information-right-side profile__main-blocks'>
                    <p className='title-information main-text profile__margin'>Социальные сети</p>
                    <div className="profile__margin">
                        {!editModeContacts &&
                            <>
                                {isOwner ?
                                    <button className="profile__button-edit-profile" onClick={() => setEditModeContacts(true)}><img src={editProfile} alt=""/></button>
                                :null}
                                {contacts}
                            </>
                        }
                        {editModeContacts && <EditModeProfileContacts contact={profile.contacts} initialValues={profile} onSubmit={onSubmit}/>}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ProfileAboutMe


